import { Checkbox, TableCell } from "@mui/material"
import {
    getNextProjectBridgeScheduleSelection,
    setProjectBridgeScheduleSelection,
    useProjectBridgeScheduleSelection,
} from "./project-bridge-selection"

export function ProjectBridgeRowSelector({ item }) {
    const scheduleId = item?.scheduleId
    const selectedScheduleIdsById = useProjectBridgeScheduleSelection()
    const selectable = Boolean(scheduleId)
    const selected = Boolean(scheduleId && selectedScheduleIdsById?.[scheduleId])

    return (
        <TableCell padding="checkbox" onClick={stopSelectionClick}>
            <Checkbox
                size="small"
                checked={selected}
                disabled={!selectable}
                onChange={handleSelectionChange}
                inputProps={{ "aria-label": `Select ${item?.code || "Project Bridge schedule"}` }}
                data-cy="project-bridge-row-selector"
            />
        </TableCell>
    )

    function stopSelectionClick(event) {
        event.stopPropagation()
    }

    function handleSelectionChange(event) {
        setProjectBridgeScheduleSelection(
            getNextProjectBridgeScheduleSelection(selectedScheduleIdsById, scheduleId, event.target.checked)
        )
    }
}
